import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {},
    tabContainer: {
      display: 'flex !important',
      flexDirection: 'column',
      width: '100%',
      border: '2px solid #FEFEFE',
      textAlign: 'left',
      padding: '16px',
      background: '#FEFEFE',
    },
    tabContainerActive: {
      display: 'flex !important',
      flexDirection: 'column',
      width: '100%',
      border: '2px solid #0949EE',
      textAlign: 'left',
      padding: '16px',
      background: '#FEFEFE',
    },
    title: {
      color: '#23272E',
      fontSize: '16px',
      fontWeight: 700,
      paddingRight: theme.spacing(1),
    },
    titleActive: {
      color: '#0031CC',
      fontSize: '16px',
      fontWeight: 700,
      paddingRight: theme.spacing(1),
    },
    subtitle: {
      color: '#5D5D5F',
      fontSize: '16px',
      fontWeight: 400,
      paddingRight: '4px',
      paddingLeft: '4px',
    },
    count: {
      paddingRight: '14px',
      fontWeight: 700,
      fontSize: '16px',
      color: '#01195B',
      paddingLeft: '4px',
    },
    countDefault: {
      paddingRight: theme.spacing(1),
      fontWeight: 700,
      fontSize: '16px',
      color: theme.palette.grey[900],
    },
    countInActive: {
      paddingRight: theme.spacing(1),
      fontWeight: 700,
      fontSize: '16px',
      color: '#616161',
    },
  };
});

export default useStyles;
